import { canUseDom } from "~/utils/can-use-dom"

/* This code exports a constant variable named `isIOS`. The value of `isIOS` is a boolean that
indicates whether the current device is an iOS device or not. */
export const isIOS = canUseDom && /(iPhone|iPod|iPad)/i.test(navigator.platform)
